// 权限管理服务接口
import { axiosInstance, live_instance } from "../instance";

// 根据cid获得用户
export const getUserByCidApi = (params) => {
    const { cid } = params
    return live_instance({
        method: 'get',
        url: `/vod-content/program/operator/list`,
        // params: {
        //     cid
        // }
    })
}

// 添加终端审核
export const addTerminalCheckApi = (data) => {
    const { id, cid, username, sn, account, status, remark } = data
    return axiosInstance({
        method: 'post',
        url: `/api/category/addTerminalCheck`,
        data: {
            id, cid, username, sn, account, status, remark
        }
    })
}

// 删除终端审核
export const deleteTerminalCheckApi = (data) => {
    const { id } = data
    return axiosInstance({
        method: 'delete',
        url: `/api/category/deleteTerminalCheck`,
        data: { id }
    })
}

// 编辑终端审核
export const editTerminalCheckApi = (data) => {
    const { id, cid, username, sn, account, status, remark } = data
    return axiosInstance({
        method: 'post',
        url: `/api/category/editTerminalCheck`,
        data: {
            id, cid, username, sn, account, status, remark
        }
    })
}

// 获取终端审核
export const getTerminalCheckApi = (params) => {
    const { cid, key, page, limit } = params
    return axiosInstance({
        method: 'get',
        url: `/api/category/getTerminalCheck`,
        params: {
            cid, key, page, limit
        }
    })
}

// 编辑终端审核状态
export const switchStatusApi = (data) => {
    const { id, cid, username, sn, account, status, remark } = data
    return axiosInstance({
        method: 'post',
        url: `/api/category/switchStatus`,
        data: {
            id, cid, username, sn, account, status, remark
        }
    })
}

// 获取CMS的角色
export const getCmsRoleApi = (params?) => {
    return axiosInstance({
        method: 'get',
        url: `/api/authority/getCmsRole`,
        params
    })
}

// 查询获取CMS用户列表
export const getCmsUserListApi = (params) => {
    const { page, limit, sortType, sortByField, roleId, name } = params
    return axiosInstance({
        method: 'get',
        url: `/api/authority/getCmsUserList`,
        params: {
            page, limit, sortType, sortByField, roleId, name
        }
    })
}

// 系统用户权限关联权限
export const addRelationAgentApi = (data) => {
    const { cid, relationAgentList, userId } = data
    return axiosInstance({
        method: 'post',
        url: `/api/category/addRelationAgent`,
        data: {
            cid, relationAgentList, userId
        },
        type: 'json'
    })
}

// 查看系统用户权限关联权限
export const checkAgentApi = (params) => {
    const { userId } = params
    return axiosInstance({
        method: 'get',
        url: `/api/category/checkAgent`,
        params: {
            userId
        }
    })
}

// 系统用户权限关联权限判断是否含有子品牌
export const checkSubAgentApi = (params) => {
    const { mainAgentId } = params
    return axiosInstance({
        method: 'get',
        url: `/api/category/checkSubAgent`,
        params: {
            mainAgentId
        }
    })
}

// 系统用户权限关联权限回显
export const getRelationAgentApi = (params) => {
    const { userId } = params
    return axiosInstance({
        method: 'get',
        url: `/api/category/getRelationAgent`,
        params: {
            userId
        }
    })
}

// 系统用户权限关联权限获取主品牌
export const getRelationMainAgentApi = (params) => {
    const { cid } = params
    return axiosInstance({
        method: 'get',
        url: `/api/category/getRelationMainAgent`,
        params: {
            cid
        }
    })
}

// 系统用户权限关联权限获取子品牌
export const getRelationSubAgentApi = (params) => {
    const { mainAgentIds } = params
    return axiosInstance({
        method: 'get',
        url: `/api/category/getRelationSubAgent`,
        params: {
            mainAgentIds
        }
    })
}

// 获取运营商管理列表
export const getOperatorListApi = (params) => {
    const { name } = params;
    return axiosInstance(
        {
            method: 'get',
            url: '/api/category/getOperatorList',
            params: { name }
        }
    );
}

// 添加运营商管理
export const addOperatorApi = (data) => {
    const { parentId, name, remark } = data;
    return axiosInstance(
        {
            method: 'post',
            url: '/api/category/addOperator',
            data: { parentId, name, remark }
        }
    );
}

// 编辑运营商管理
export const editOperatorApi = (data) => {
    const { id, name, remark } = data;
    return axiosInstance(
        {
            method: 'put',
            url: '/api/category/editOperator',
            data: { id, name, remark }
        }
    );
}

// 删除运营商管理
export const deleteOperatorApi = (params) => {
    const { ids } = params;
    return axiosInstance(
        {
            method: 'delete',
            url: '/api/category/deleteOperator',
            params: { ids },
        }
    );
}

// 获取运营商管理下拉数据列表(树形结构, 包含default)
export const getOperatorNameListApi = () => {
    return live_instance(
        {
            method: 'get',
            url: '/agent/operator/options',
        }
    );
}

// 系统用户权限关联运营商
export const editCmsOperatorApi = (data) => {
    const { operatorId, userId } = data;
    return axiosInstance(
        {
            method: 'post',
            url: '/api/authority/editCmsOperator',
            data: { operatorId, userId },
            type: 'json'
        }
    );
}

// 查询运营商下的用户
export const getUsernameByOperationIdApi = (params) => {
    const { operationId } = params
    return axiosInstance({
        method: 'get',
        url: `/api/authority/getUsernameByOperationId`,
        params: { operationId }
    })
}
